import React, { Component } from 'react'
import './evaluation-report.scss'
import { ImageConstants, Constants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import SchoolUserApi from '../../../apis/student'
import Dropdown from '../../common/dropdown-v2/dropdown'
import SessionCache from '../../routes/session-cache'

class EvalutionReportV2 extends Component {
  state = {
    noviceStudents: [],
    proficientStudents: [],
    advancedStudents: [],
    types: []
  }

  componentDidMount () {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
    this.getEvaluationReport(payload)
  }

  getEvaluationReport (payload = {}) {
    const { event } = this.props
    payload.eventId = event._id
    this.setState({ isLoading: true })

    SchoolUserApi.getEventEvaluationReport(payload)
      .then(response => {
        this.setState({
          noviceStudents: response.noviceStudents,
          proficientStudents: response.proficientStudents,
          advancedStudents: response.advancedStudents,
          isLoading: false
        })
      })
      .catch(err => {})
  }

  assignHomework = _ => {
    let userInfo = SessionCache.getUser()
    const { event, selectedClass } = this.props
    const payload ={}
    payload.eventId = event._id
    payload.class = selectedClass
    payload.schoolId = userInfo?.schoolInfo?.schoolCode || ""
    this.setState({ isLoading: true })
    SchoolUserApi.assignHomework(payload)
    .then(response => {
      this.setState({
        isLoading: false
      }, _ => {
        this.showToaster('info', 'Homework Assigned to Students Successfully')
      })
    })
    .catch(err => {
      console.log(err)
    })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  render () {
    return (
      <>
        <div className='evaluation-report-v2'>
          <div className='report-card-wrapper'>
            {/* {this.state.types.map((type, index) => ( */}
            <div className='report-card col-4'>
              <div
                className='report-card-header'
                style={{ backgroundColor: '#8B8BF6' }}
              >
                <div className='row header-items'>
                  <div className='col-7 text-center'>
                    <span>
                      <span className='header-title'>Struggler</span> |{' '}
                      <strong>{'< 50 %'}</strong>
                    </span>
                  </div>
                </div>
              </div>

              <div className='report-card-concept'>
                <div className='row mt-4 concept-container'>
                  <div className='col'>
                    <div className='concept-label'>Concepts</div>
                    <Dropdown
                      key='users'
                      placeholder='Select from the list'
                      options={[]}
                      onSelect={option => {
                        console.log(option)
                      }}
                      text='title'
                      style={{ background: '#F6F7F5' }}
                      value={this.state.selectedConcepts}
                    />
                  </div>
                </div>
              </div>
              <div className='report-card-body'>
                {this.state?.noviceStudents.length ? (
                  this.state.noviceStudents.map((user, index) => (
                    <div className='row mt-4'>
                      <div className='col-12'>
                        <div className='student-card'>
                          <div className='user-image'>
                            {user.image ? (
                              <img
                                className='user-image'
                                alt='img'
                                src={`${user.basePath}${user.image}`}
                              />
                            ) : (
                              <img
                                className='user-image'
                                alt='img'
                                src={Constants.ALTERNATE_STUDENT_IMAGE}
                              />
                            )}
                          </div>
                          <div className={`user-details `}>
                            <span className='user-name'>{user.name}</span>
                            <span className='roll-no'>
                              Roll No - {user.rollNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='no-data text-center'>
                    <img
                      className=''
                      src={getImageSource(ImageConstants.NO_DATA)}
                    />
                    <div className='empty'>This is Empty</div>
                    <div className='no-student'>No Student in this bucket</div>
                  </div>
                )}
              </div>
            </div>
            <div className='report-card col-4'>
              <div
                className='report-card-header'
                style={{ backgroundColor: '#FFBB7C' }}
              >
                <div className='row header-items'>
                  <div className='col-7 text-center'>
                    <span>
                      <span className='header-title pl-4'>Proficient</span> |{' '}
                      <strong>{'50%-80%'}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div className='report-card-concept'>
                <div className='row mt-4 concept-container'>
                  <div className='col'>
                    <div className='concept-label'>Concepts</div>
                    <Dropdown
                      key='users'
                      placeholder='Select from the list'
                      options={[]}
                      onSelect={option => {
                        console.log(option)
                      }}
                      text='title'
                      style={{ background: '#F6F7F5' }}
                      value={this.state.selectedConcepts}
                    />
                  </div>
                </div>
              </div>
              <div className='report-card-body'>
                {this.state?.proficientStudents.length ? (
                  this.state.proficientStudents.map((user, index) => (
                    <div className='row mt-4'>
                      <div className='col-12'>
                        <div className='student-card'>
                          <div className='user-image'>
                            {user.image ? (
                              <img
                                className='user-image'
                                alt='img'
                                src={`${user.basePath}${user.image}`}
                              />
                            ) : (
                              <img
                                className='user-image'
                                alt='img'
                                src={Constants.ALTERNATE_STUDENT_IMAGE}
                              />
                            )}
                          </div>
                          <div className={`user-details `}>
                            <span className='user-name'>{user.name}</span>
                            <span className='roll-no'>
                              Roll No - {user.rollNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='no-data text-center'>
                    <img
                      className=''
                      src={getImageSource(ImageConstants.NO_DATA)}
                    />
                    <div className='empty'>This is Empty</div>
                    <div className='no-student'>No Student in this bucket</div>
                  </div>
                )}
              </div>
            </div>
            <div className='report-card col-4'>
              <div
                className='report-card-header'
                style={{ backgroundColor: '#80D2F4' }}
              >
                <div className='row header-items'>
                  <div className='col-7 text-center'>
                    <span>
                      <span className='header-title'>Advance</span> |{' '}
                      <strong>{'> 80 %'}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div className='report-card-concept'>
                <div className='row mt-4 concept-container'>
                  <div className='col'>
                    <div className='concept-label'>Concepts</div>
                    <Dropdown
                      key='users'
                      placeholder='Select from the list'
                      options={[]}
                      onSelect={option => {
                        console.log(option)
                      }}
                      text='title'
                      style={{ background: '#F6F7F5' }}
                      value={this.state.selectedConcepts}
                    />
                  </div>
                </div>
              </div>
              <div className='report-card-body'>
                {this.state?.advancedStudents.length ? (
                  this.state.advancedStudents.map((user, index) => (
                    <div className='row mt-4'>
                      <div className='col-12'>
                        <div className='student-card'>
                          <div className='user-image'>
                            {user.image ? (
                              <img
                                className='user-image'
                                alt='img'
                                src={`${user.basePath}${user.image}`}
                              />
                            ) : (
                              <img
                                className='user-image'
                                alt='img'
                                src={Constants.ALTERNATE_STUDENT_IMAGE}
                              />
                            )}
                          </div>
                          <div className={`user-details `}>
                            <span className='user-name'>{user.name}</span>
                            <span className='roll-no'>
                              Roll No - {user.rollNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='no-data text-center'>
                    <img
                      className=''
                      src={getImageSource(ImageConstants.NO_DATA)}
                    />
                    <div className='empty'>This is Empty</div>
                    <div className='no-student'>No Student in this bucket</div>
                  </div>
                )}
              </div>
            </div>
            {/* ))} */}
          </div>
          <div className='row mt-4'>
            <div className='col text-center mx-2'>
              <button className={`cw-button-primary cw-button-homework`} onClick={this.assignHomework}>Assign Homework</button>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default EvalutionReportV2
